import React from "react"
import { Navigate } from "react-router-dom"

import { haveAuth } from "utils"

const ProtectedRoute = props => {
  const { children, requiredAccesses } = props

  if (!haveAuth(requiredAccesses, "needMultipleAccesses"))
    return <Navigate to="/404" />

  return children
}

export default ProtectedRoute